import requestService from '../requestService';
import store from '@/store';

export default {
    async getAllSocial() {
        const response = await requestService.get('/social', {
            headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
        })
        return response?.data
    },
    async getSocial(uid) {
        const response = await requestService.get(`/social/${uid}`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
        })
        return response?.data
    },
    async createSocial(form) {
        const response = await requestService.post(`/social`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
        })
        return response?.data
    },
    async updateSocial(sid, form) {
        const response = await requestService.post(`/social/${sid}`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
        })
        return response?.data
    },
    async checkName(form) {
        const response = await requestService.post('/social/check_name', form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
        })
        if (response?.data) {
            return response?.data
        }
    }
};